import { createSelector } from 'reselect';
import { DELIVERY_TYPE_NO_DELIVERY } from '../views/delivery/reducers/delivery';
import { getNoDeliveryOptions } from '../selectors/delivery.js'

const getMemberState = state => state.member;
const getDeliveryState = state => state.delivery;
const getReservationState = state => state.reservation;
const getInsurance = state => state.insurance;
const getDonationState = state => state.donations;
const isKioskMode = state => state.payment.method === 13;

export const getMemberPayload = createSelector([getMemberState], (member) => {
    let splitName = member.name.split(" ");
    let payload = {
        first_name: splitName[0],
        last_name: splitName[1],
        email: member.email,
        phone: member.phone,
        send_account_email: false,
    };

    if (member.address) {
        payload.address = member.address.address;
        payload.address2 = member.address.address2;
        payload.city = member.address.city;
        payload.state = member.address.state;
        payload.zip = member.address.zip;
        payload.country = member.address.country;
    }

    return payload;
});

export const getDeliveryPayload = createSelector(
    [getDeliveryState, getReservationState, getMemberState, isKioskMode],
    (delivery, reservation, member, isKiosk) => {
    let payload = {
        id: reservation.selected_delivery_option !== '' ? reservation.selected_delivery_option : delivery.id,
        email: delivery.email ? delivery.email : member.email,
        numbers: [{number: delivery.phone, countryCode: delivery.countryCode}],
        address: delivery.address
    };

    if (isKiosk && !payload.id) {
        let noDeliveryOptions = getNoDeliveryOptions({delivery: delivery});
        if (noDeliveryOptions.length) {
            payload.id = noDeliveryOptions[0].id;
        }
    }

    return payload;
});

export const getInsurancePayload = createSelector([getInsurance], (insurance) => {
    let payload = {
        provider: insurance.selected,
        status: insurance.selected === "ticketguardian" ? true : false,
        quote: insurance.price,
        token: insurance.quoteToken,
    };

    return payload;
});

export const getDonationsPayload = createSelector([getDonationState], (donation) => {

    let payload = {};

    Object.keys(donation.userDonations).map(eventId => {
        payload[eventId] = donation.userDonations[eventId];
    });

    return payload;
});
